import type {
  IOptions,
  EmailTemplateOptions,
  IOptionsApplication,
  IOptionsWorkflowTemplates
} from "@/models/options";
import { axiosClient } from "../client";
import endpoints from "../endpoints";

class OptionsApiService {
  async getOptions() {
    const response = await axiosClient.get<{ data: IOptions }>(
      endpoints.GET_OPTIONS.ALL
    );
    return response.data.data;
  }
  async getEmailTemplatesOptions() {
    const response = await axiosClient.get<{ data: EmailTemplateOptions }>(
      endpoints.GET_OPTIONS.EMAIL_TEMPLATES
    );
    return response.data.data;
  }
  async getApplicationsOptions() {
    const response = await axiosClient.get<{ data: IOptionsApplication }>(
      endpoints.GET_OPTIONS.APPLICATION
    );
    return response.data.data;
  }
  async getWorkflowTemplatesOptions() {
    const response = await axiosClient.get<{ data: IOptionsWorkflowTemplates }>(
      endpoints.GET_OPTIONS.WORKFLOW_TEMPLATES
    );
    return response.data.data;
  }
}

const optionsApiService = new OptionsApiService();
export default optionsApiService;
